<template>
  <div>
    <base-crud
      :ref="table"
      :crudName="crudName"
      :newText="newText"
      :table="table"
      :columns="columns"
      :options="options"
      :endPoint="endPoint"
      :enableAdd="true"
      :enableEdit="false"
      :enableDelete="false"
      :enableView="false"
      :dataForm="dataForm"
      :detailUrl="detailUrl"
      :extra="extra"
      @view="view"
    ></base-crud>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
export default {
  data() {
    return {
      extra: [
        {
          id: 1,
          label: "",
          class: "btn btn-crud yellow",
          title: "Visualizar",
          name: "view",
          icon: "fas fa-eye",
        }
      ],
      crudName: "Envios avulsos",
      newText: "Cadastrar Envios",
      table: "detatchedsTable",
      columns: ["id", "name", "actions"],
      tableData: ["id", "name"],
      options: {
        sortIcon: {
          base: "space_fas fas",
          is: "fa-sort",
          up: "fa-sort-amount-up",
          down: "fa-sort-amount-down",
        },
        filterByColumn: true,
        debounce: 1000,
        sortable: ["id", "name", "company_id", "branch_id", "sector_id"],
        filterable: ["id", "name", "company_id", "branch_id", "sector_id"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          id: "#",
          name: "Nome",
          actions: "Ações",
        },
        templates: {},
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = "";

          return this.$http.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "signaturebatches/",
      dataForm: {},
      detailUrl: "detatched",
    };
  },
  methods: {
    view(props) {
      const self = this;
      self.$router.push('signaturebatches/view/' + props.row.id)
    },
    query: function (query) {
      let columns = {
        id: "id",
        name: "name",
      };
      let filters = "&is_detatched_sending=1&orderByDesc=id&";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });

      return filters;
    },
  },
  mounted() {},
  components: {
    BaseCrud,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Detatched/Crud.vue